<script>
export default {};
</script>
<template>
  <div class="writeart_block">
    <div class="btn">write new article</div>
  </div>
</template>
<style lang="scss" scoped>
.writeart_block {
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  padding: 20px 30px;

  .btn {
    text-transform: uppercase;
    background: #0077b5;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 10px 30px;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
  }
}
</style>
